import { IOnChangesObject } from 'angular';
import { Modal, ModalService } from '../../services/Utils/Modal';

export class UsersPickerController implements ng.IComponentController {
  usersIds: Set<string>;

  // bindings
  max: number;
  selectedUsers: string[];
  isDisabled: boolean;
  onSave: ({}: { usersIds: string[] }) => void;

  constructor(private modalService: ModalService) {
    'ngInject';
  }

  $onInit(): void {
    this.usersIds = new Set(this.selectedUsers);
  }

  $onChanges(onChangesObj: IOnChangesObject): void {
    if (onChangesObj.selectedUsers) {
      this.usersIds = new Set(onChangesObj.selectedUsers.currentValue);
    }
  }

  openSelectionModal(): Modal {
    const template = `
      <users-picker-modal
        max="$ctrl.max"
        selected-users="$ctrl.selectedUsers"
        on-save="$ctrl.onSave(usersIds)"
        on-close="$ctrl.onClose()"
      ></users-picker-modal>
    `;

    return this.modalService.open(template, {
      max: this.max,
      selectedUsers: Array.from(this.usersIds),
      onSave: (usersIds: string[]) => {
        this.onSave({ usersIds });
      },
    });
  }
}
